<template>
  <div class="home">
    <section class="section container">
        <p class="title">Websummit 2019</p>
        <p class="subtitle">Talk Explorer</p>
        <p>Developed by: <a href="https://marcossoares.pt">Marcos Soares</a></p>
        <br>
        <p class="description">This is an unofficial viewer of Websummit 2019 videos, where you can filter by day/stage or favorite some videos to watch later.</p>
    </section>

    <button @click="goToTop()" class="button is-primary to-top-button"><b-icon
                    pack="fas"
                    size="large"
                    icon="arrow-alt-circle-up"
                ></b-icon></button>
    <!-- <button @click="download(all_talks, 'json.txt', 'text/plain')">download</button> -->

    <section class="section container"> 
      <div class="">

        <b-field grouped>
          <b-field label="Filter by day:" expanded>
            <b-select placeholder="Select a day" v-model="day_selected" class="has-text-centered">
                <option
                    v-for="option in day_options"
                    :value="option.value"
                    :key="option.value">
                    {{ option.name }}
                </option>
            </b-select>
          </b-field>
          <b-field label="Only Favorites" expanded>
            <b-switch @click.native="filter_by_favorites(only_favorites)" v-model="only_favorites">Show Only Favorites</b-switch>
          </b-field>
          <b-field label="Delete Favorites" expanded>
            <b-button @click="deleteFavorites()" class="is-danger">Delete</b-button>
          </b-field>
        </b-field>  
      </div>
    </section>
    <section class="section">
      <div class="container">
        <b-field label="Filter by Stage(s) of your interest" class=""></b-field>
          <div class="has-text-centered mb-3">
            <p class="size-is-3 ">currently {{filtered_talks.length}} talk{{filtered_talks.length>1?'s':''}} selected</p>
          </div>
          <b-taglist style="margin-top:20px;">
            <a class="tag-item" @click="add_remove_stage(stage)" v-for="stage in stage_names" :key="stage" >
              <b-tag :type="filtered_stages.includes(stage)? 'is-info' : ''" >{{stage}}</b-tag>
            </a>
          </b-taglist>
        
      </div>
    </section>
    <section class="section"> 
      <div v-if="filtered_talks.length > 0" class="container">
        <div class="columns is-multiline is-mobile" v-for="row in Math.ceil(filtered_talks.length / 4)" :key="row.id">
          <div v-for="talk in filtered_talks.slice((row - 1) * 4, row * 4)" class="column is-one-quarter-desktop is-half-tablet is-full-mobile" :key="talk.id">
            <NewVideoCard :favorites="favorites" :talk="talk" />
          </div>
        </div>
      </div>
      <div class="container" v-else ><p class="subtitle">no talks found...</p></div>
    </section>
    <!-- {{all_talks}} -->


  </div>
</template>

<script>
import NewVideoCard from '@/components/NewVideoCard.vue'
// import day01 from '@/json/04_11_2019.json'
// import day02 from '@/json/05_11_2019.json'
// import day03 from '@/json/06_11_2019.json'
// import day04 from '@/json/07_11_2019.json'
import all_data from '@/json/full_parsed.json'


export default {
  components: {
    NewVideoCard
  },
  data() {
    return {
      all_talks: all_data,
      filtered_talks: [],
      filted_by_day: [],
      day_options: [
        {
          name: 'all',
          value: 0,
        },
        {
          name: 'day 1', 
          value: 1,
        },
        {
          name: 'day 2',
          value: 2,
        },
        {
          name: 'day 3',
          value: 3,
        },
        {
          name:'day 4',
          value: 4,
        }
      ],
      day_selected: 0,
      stage_names: ["Centre Stage", "Registration", "Night Summit", "Sustainability", " Privacy", "Whistleblowers", "PandaConf", "Future Societies", "Auto/Tech & TalkRobot", "Venture", "Q + A", "Corporate Innovation Summit", "Growth Summit", "Roundtables", "Workshops", "Away from the stage", "creatiff", "planet:tech ", "SportsTrade", "UnBoxed", "PITCH 1", "PITCH 2", "PITCH 3", "SaaS Monster", "Startup University", "Developers", "Women in tech", "AI", "Automotive", "eCommerce", "Investment", "Marketing", "Politics", "Robotics", "Social media", "Travel", "ContentMakers", "MoneyConf", "Startup Showcase 2", "Startup Showcase 3", "binate.io", "DeepTech", "Startup Showcase 1", "Tax", "MusicNotes", "Modum", "FullSTK", "HealthConf", "Machine Demo"],
      filtered_stages: [],
      only_favorites: false,
      favorites: []
    }
  },
  computed: {

  },
  created() {
    this.filter_by_day(0)
    this.favorites = this.fetchFavorites()
  },
  mounted() {
    
  },
  watch: {
    day_selected(day){
      this.filter_by_day(day)
    },
    filtered_stages(stages) {
      if (stages.length != 0){
        this.filter_by_stage(stages)
      }
    },
    // favorites(favorites){
    //   console.log('favorites', favorites)
    //   localStorage.setItem('favorites', favorites)
    // }
  },
  methods: {
    goToTop(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    fetchFavorites(){
        let favs = JSON.parse(localStorage.getItem('favorites'))
        if (favs == null){
            favs = []
        }
        return favs
    },
    deleteFavorites(){
      this.favorites = []
      localStorage.setItem('favorites', JSON.stringify(this.favorites))
      this.filtered_talks = []
      this.filter_by_day(this.day_selected)
    },
    filter_by_favorites(state){
      this.favorites = this.fetchFavorites()
      console.log("filtering by favorites:", !state)
      if (!state) {
        let favorites = []
        let favs = JSON.parse(localStorage.getItem('favorites'))
        if (favs == null){
          favs = []
        }
        favs.forEach(fav => {
          favorites.push(all_data[fav])
        });
        console.log("favorites:", favorites)
        this.all_talks = favorites
      } else {
        this.all_talks = all_data
      }
      this.filter_by_day(this.day_selected)
    },
    add_remove_stage(stage) {
      let includes = this.filtered_stages.includes(stage)
      if (!includes){
        this.filtered_stages.push(stage)
      } else {
        var index = this.filtered_stages.indexOf(stage);
        if (index !== -1) {
          this.filtered_stages.splice(index, 1);
        }
        if(this.filtered_stages.length == 0){
          this.filter_by_day(this.day_selected)
        }
      }
      
    },
    filter_by_day(day){ // use 1 to 4
      console.log("filtering by day: ", day)
      let filtered = []

      if(day == 0) {
        filtered = this.all_talks
      } else {
        let dates = ['2019-11-04','2019-11-05','2019-11-06','2019-11-07']
        let date = dates[day-1]
        this.all_talks.forEach(talk => {
          if (talk.date == date){
            filtered.push(talk)
          }
        });
      }
      this.filted_by_day = filtered // backup for filter_by_stage
      this.filtered_talks = filtered

      if (this.filtered_stages.length != 0 ) {
        console.log("going to filter by stage")
        this.filter_by_stage(this.filtered_stages)
      }
    },
    filter_by_stage(stages){
      console.log("filtering by stages:", stages)
      let filtered = []
      this.filted_by_day.forEach(talk => {
        if (stages.includes(talk.stage)){
          filtered.push(talk)
        }
      });
      this.filtered_talks = filtered
    }
    // download(content, fileName, contentType) { // not used in production, only used to generate "full_parsed.json"
    //   var a = document.createElement("a");
    //   var file = new Blob([JSON.stringify(content)], {type: contentType});
    //   a.href = URL.createObjectURL(file);
    //   a.download = fileName;
    //   a.click();
    // },
    // parse_data_from_raw_jsons() { // not used in production, only used to generate "full_parsed.json"
    //   let all_days = [day01, day02, day03, day04]
    //   let stages = []
    //   let that = this
    //   let count = 0
    //   all_days.forEach(day => {
    //     let day_talks = day.data.conference.schedule.day.stages.nodes
    //     day_talks.forEach(stage => {
    //         if (!stages.includes(stage.name)){
    //           stages.push(stage.name)
    //         }
    //         stage.timeslots.nodes.forEach( talk => {
    //           if (talk.video){
    //             that.all_talks.push(
    //               {
    //                 index: count,
    //                 date: day.data.conference.schedule.day.date,
    //                 stage: stage.name,
    //                 talk: talk,
    //               }
    //             )
    //             count++
    //           }
    //         });
    //     });
    //   });
    //   return stages;
    // },
  }
}
</script>

<style>
.tag-item{
  margin-left: 5px;
  margin-right: 5px;
}
.tag:hover {
  background-color: rgb(230, 230, 230);
}

.filters .field {
  margin-right: 50px !important;
}

.to-top-button {
    position: fixed !important;
    right: 20px !important;
    bottom: 20px !important;
    width: 40px !important;
    height: 40px !important;
    z-index: 99999;
}

/* .control {
  tex
} */

</style>
